import {Injectable} from '@angular/core';
import {AuthService} from '@auth0/auth0-angular';
import {clearSessionState} from './session-state';

@Injectable({providedIn: 'root'})
export class LogoutService {

    constructor(private authService: AuthService) {
    }

    logout(): void {
        clearSessionState();

        this.authService.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    }
}
